import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {invoicesActions} from '../../../../state/actions/invoice.actions';
import TransactionDetailsPanel from '../../TransactionsPage/TransactionDetailsPanel';
import TransactionDetails from '../../TransactionsPage/TransactionDetails/TransactionDetails';
import {
  systemHelpers,
  transactionsHelpers
} from '../../../../utils/helpers';
import {firebaseEvents} from '../../../../snippets/firebase';

const {logEvent} = systemHelpers;

const TransactionDetailsSection = ({
  unlinkExpense,

  edit = false,
  onBack,
  onExpenseUpdate,
  subscription,
  transaction,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'subscriptions', 'cards']);

  const successChangeInvoiceHandle = (response, successCallback) => {
    successCallback && successCallback(response);
    logEvent(firebaseEvents.CARDS_UPDATE_TRANSACTION_INVOICE);
  }

  const onInvoiceRemove = (successCallback, errorCallback) => {
    transactionsHelpers.removeInvoiceFromTransaction({
      t,
      transaction,
      successCallback: (response) => successChangeInvoiceHandle(response, successCallback),
      errorCallback,
      unlinkExpense,
      onExpenseUpdate
    });
  }

  return (
    <TransactionDetailsPanel
      backButtonText={t('back')}
      className='transaction-details-panel'
      contentClassName='transaction-details-panel-content'
      onBack={onBack}
      {...rest}
    >
      <TransactionDetails
        edit={edit}
        onExpenseUpdate={onExpenseUpdate}
        onInvoiceRemove={onInvoiceRemove}
        subscription={subscription}
        transaction={transaction}
      />
    </TransactionDetailsPanel>
  );
}

TransactionDetailsSection.propTypes = {
  edit: PropTypes.bool,
  onBack: PropTypes.func,
  onExpenseUpdate: PropTypes.func,
  subscription: PropTypes.object,
  transaction: PropTypes.object,
}

const mapDispatchToProps = {
  unlinkExpense: invoicesActions.unlinkExpense,
}

export default connect(null, mapDispatchToProps)(TransactionDetailsSection);
